<template>
  <div>
    <div class="title-dialog">
      <p style="font-size: 30px; font-family: Roboto; font-weight: 100;">{{$t('forgot_password')}}</p>
    </div>
      
    <div class="icon-close">
      <b-icon stacked icon="x" @click="closeDialog()" scale="1.1" class="style-x" v-b-tooltip.hover title="Fechar" ></b-icon>
    </div>

    <div class="wrapper-form">
      <b-form>
        <b-form-group label="E-mail">
          <b-form-input
          id="input-1"
          v-model="email"
          type="email"
          required
          ></b-form-input>
        </b-form-group>

      </b-form>

      <div>
        <b-button @click="forgotPassword()" class="btn_1">
              {{$t('btn_send_email')}}
        </b-button>
      </div>
     
    </div>    
  </div>
</template>

<script>
import firebase from '@/firebaseInit.js';
import store from "@/store"
import i18n from '@/i18n.js'

export default {
    data() {
        return {
            email: "",
           
        };
    },
    methods: {
      forgotPassword(){
        try{
          firebase.auth().sendPasswordResetEmail(this.email).then(()=> {
            this.$bvModal.msgBoxOk(i18n.t('emailSent'), {
              title: i18n.t('msgTitleInfo'),
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              centered: true
            }).then(value => {
              this.closeDialog()
            })



          }).catch(error=> {
              this.$bvModal.msgBoxOk(i18n.t(error.code), {
                        title: i18n.t('msgTitleWarning'),
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'warning',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                        centered: true
              })
            console.log(error);
          });
        }catch(e){
           console.log(error);
        }
       
      },

      closeDialog: function(){
         this.$emit('showDialogForgotPassword', false )
      },
    }    
}
</script>

<style lang="scss" scoped>
  .wrapper-form{
    color: #fff;
    width: 435px;
    padding: 100px 20px 30px 20px;

    ::v-deep.form-control{
      padding: 0;
      font-size: inherit;
    }
    
        
  }
</style>
